import * as SearchformActions from '../actions/searchform';
import { SearchformResponseModel } from '../../shared/models/searchform-response.model';

export interface State {
	searchform: SearchformResponseModel;
}

export const InitialState: State = {
	searchform: null
};

export function reducer(state: State = InitialState, action: SearchformActions.All): State {
	switch (action.type) {
		case SearchformActions.SET_SEARCHFORM_SUCCESS:
			return {...state, ...({searchform: (<SearchformActions.SetSearchformSuccess>action).payload})};

		default:
			return state;
	}
}

export const Searchform = (s: State): SearchformResponseModel => s.searchform;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/searchform.ts